import React from "react";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import "../../../../css/Common/Components/DesignSystem/Arrow.css";

// ArrowLeft is a React component that renders a left arrow button with click effects.
class ArrowLeft extends React.Component {
  constructor() {
    super();

    // Initialize component state
    this.state = {
      clicked: false,      // Tracks if the arrow has been clicked
      greenClicked: false, // (Unused) Could be used for a different click state
    };
  }

  render() {
    const { onClick, disabled } = this.props;
    return (
      // Container div for the arrow, applies classes based on state and props
      <div
        className={`Arrow-Container ${this.state.clicked ? "clicked" : ""}  ${
          disabled ? "disabled" : ""
        }`}
        onClick={() => {
          // Toggle clicked state and call onClick prop if not disabled
          this.setState({ clicked: !this.state.clicked });
          !disabled && onClick();
        }}
      >
        {/* MUI IconButton containing the left chevron icon */}
        <IconButton className="Arrow-Icon" disableRipple>
          <ChevronLeftIcon className="Arrow-Icon" />
        </IconButton>
      </div>
    );
  }
}

export default ArrowLeft;
